import { useModal } from '@ebay/nice-modal-react'
import { Route, useSearch } from '@tanstack/router'
import { lazy, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { MessageModal, PasswordResetModal } from '../components/common'
import { useBoundStore } from '../store/store'
import type { ApiResponse } from '../types/api'
import type { ResetCredentials } from '../types/user'
import { api } from '../utils/api-client'
import { rootRoute } from './root'

const Casino = lazy(() => import('../pages/casino'))

const IndexPage = () => {
  const username = useBoundStore(state => state.user.username)
  const messageModal = useModal(MessageModal)
  const passwordResetModal = useModal(PasswordResetModal)
  const { t } = useTranslation('common')

  const { reset_password }: { reset_password?: string } = useSearch({
    from: '/',
  })

  // Tracks which reset_password value has already been processed so the
  // verification request and modal fire exactly once per unique query value.
  // useModal() returns a fresh object every render, so it must stay out of the
  // effect deps to avoid an infinite request/render loop.
  const verifiedHash = useRef<string>()

  useEffect(() => {
    if (!reset_password) return
    if (verifiedHash.current === reset_password) return
    verifiedHash.current = reset_password

    if (username) {
      messageModal.show({
        title: '',
        message: t('already-logged-in'),
      })

      return
    }
    const reqBody = { type: 'verify_reset_password', hash: reset_password }
    api
      .post('/request.php', reqBody)
      .then(res => {
        const { status, info } = res.data as ApiResponse<
          ResetCredentials | string
        >
        if (status === 1 && typeof info !== 'string') {
          passwordResetModal.show({
            code: info?.code ?? '',
            email: info?.email ?? '',
          })
        } else if (typeof info === 'string') {
          messageModal.show({
            title: t('system'),
            message: info,
          })
        }
      })
      .catch(err => {
        messageModal.show({
          title: t('system'),
          message: err instanceof Error ? err.message : '',
        })
      })
  }, [reset_password, username])

  return <Casino category="inicio" />
}

export const indexRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexPage,
})
